<template>
  <div id="footer">
    <TermsPopUp
      ref="terms"
      :class="termsFlag"
      @termsToggleChange="termsToggleChange"
      :selectedUrl="selectedUrl"
    />
    <div class="App_footer">
      <div class="terms">
        <span v-for="term in agreeList" :key="term.name"
          @click="termsDetailOpenHardCode(term)" :class="{'fwb': term.name == '개인정보처리방침'}">
          {{ $t(term.name) }}
        </span>
      </div>
      <div class="App_f_logo"></div>
      <address class="App_f_addr">
        {{$t('companyInfo.info1')}}<br>
        {{$t('companyInfo.info3')}}<br>
        {{$t('companyInfo.info2')}}<br>
        {{ $t('companyInfo.info4') }}
      </address>
      <div>
        <div class="App_f_tel" @click="arrowChange()" v-if="this.arrowFlag">
          <div>{{$t('customerCenter')}}<span class="App_arrowClose"></span></div>
        </div>
        <div class="App_f_tel" @click="arrowChange()" v-else>
          <div>{{$t('customerCenter')}}<span class="App_arrowOpen"></span></div>
          <p>
            <!-- <span @click="openKakao()">{{$t('kakaoChannel')}}</span><br> -->
            <span class="link-touch" @click="openKakao()">{{$t('companyInfo.kakaoChannel')}}</span><br>
            ({{$t('weekdays')}} 09:00 ~ 18:00)<br>
            <!-- {{$t('eMail')}} modnpay@seeroo.co.kr -->
          </p>
        </div>
      </div>
<!--      <p class="f_tel" v-else>-->
<!--        <strong>{{$t('customerCenter')}}</strong>-->
<!--        <span>02)3275-1700 ({{$t('weekdays')}} 09:00 ~ 18:00)</span>-->
<!--      </p>-->
      <p class="noti">
        {{ $t('companyInfo.notice') }}
      </p>
    </div>
    <!-- <a class="test" href="https://sales.modnpay.kr/policyView?seq=7">약관</a> -->
    <!-- <div @click="test" class="test">약관</div> -->
  </div>
</template>
<script lang="js">
import service from '@/backend/modnpay_app_api'
import TermsPopUp from '@/components/Terms/TermsPopUp.vue'
export default {
  components: {
    TermsPopUp
  },
  data () {
    return {
      arrowFlag: true,
      termsToggle: false,
      agreeList: [], // 약관 리스트
      selectedUrl: ''
    }
  },
  created () {
    this.setTermsByHardCode()
  },
  methods: {
    test () {
      this.$router.push({ name: 'Terms' })
      // window.open('https://ds2.modnpay.kr/ce62c588-d4e3-4d61-b038-5b0b6900e9ec', 'width = 1280, height = 400', '_blank')
    },
    arrowChange () {
      this.arrowFlag = !this.arrowFlag
    },
    termsToggleChange () { // 약관 팝업
      this.termsToggle = !this.termsToggle
    },
    async agreementList () { // 약관 목록 조회
      const req = {
        agreementType: 2
      }
      const { data } = await service.agreementList(req)
      const code = data.resultCode

      if (code === 0) {
        this.agreeList = data.agreementList
      }
    },
    termsDetailOpenHardCode (term) {
      /**
       * TODO : 약관 새창 열기 기능 사용 시 주석 해제 , TermMixins와 코드 같은지 확인 후 통합 필요
       */
      this.openTermWindow(term) // 브릿지 함수로 새 탭 열기
      /**
       * TODO : 약관 새창 열기 기능 사용 시 주석 처리 , TermMixins와 코드 같은지 확인 후 통합 필요
       */
      // this.$nextTick(async () => {
      //   const termModal = this.$refs.terms
      //   termModal.setTerm(term)
      //   await termModal.rawPdfContent()
      //   const container = termModal.$el.querySelector('.pop-terms-body')
      //   if (container) container.scrollTop = 0
      // })
      // this.termsToggle = !this.termsToggle
    },
    setTermsByHardCode () {
      const baseUrl = 'https://partner.modnpay.kr/policyView?seq='
      this.agreeList = [
        {
          name: 'terms.termsOfService',
          url: `${baseUrl}5`
        },
        {
          name: 'terms.privacyPolicy',
          url: `${baseUrl}14`
        },
        {
          name: 'terms.electronicPaymentTerms',
          url: `${baseUrl}6`
        },
        {
          name: 'terms.locationServiceTerms',
          url: `${baseUrl}7`
        }
      ]
    },
    openKakao () {
      this.openWindowView()
    }
  },
  computed: {
    termsFlag () { // 약관을 눌렀을때 position top 조정
      return this.termsToggle ? 'show' : ''
    }
  },
  watch: {
    termsToggle () {
      if (this.termsToggle) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').removeAttribute('style')
      }
    }
  }
}
</script>
<style scoped>
  #footer {
    margin-bottom: 21vw;
  }
  .test{
    width: 100px;
    text-align: center;
    font-size: 30px;
    padding: 10px;
    margin-left: 20px;
    border: 1px solid #000;
  }
  .noti {
    border-top: 1px solid #e4e4e4;
    margin-top: 15px;
    padding-top: 15px;
    color: rgba(51, 51, 51, 0.7019607843137254);
    font-size: 14px;
  }
  .link-touch {
    color: #1976d2;
    text-decoration: underline;
    cursor: pointer;
  }
</style>
